import OrderAction from './orderAction';
import Attendee from '../../../models/attendeeModel';
import RotateBarcode from '../../attendee/actions/rotateBarcode';
import RotateBarcodePostAction from '../../attendee/post-action/rotateBarcodePostAction';
import Order from '../models/orderModel';
import { TICKET_SWAP_DISTRIBUTOR } from '../../../models/distributor';

export default class RotateBarcodeOrder extends OrderAction {
    static NAME = 'rotate_barcode';
    static POST_ACTION_COMPONENT = RotateBarcodePostAction;

    static condition(order) {
        return (
            ['valid', 'reservation'].includes(order.status) &&
            order.attendee_count > order.attendees_deleted_count &&
            order.origin !== 'weez_invitation' &&
            order.distributor !== TICKET_SWAP_DISTRIBUTOR
        );
    }

    static is_attendee_valid({ attendee, order }) {
        return RotateBarcode.is_attendee_valid({ attendee, order });
    }

    static is_available({ event, mode }) {
        return !['over', 'closed'].includes(event.status) && !event.removed && mode !== 'list';
    }

    run({ attendees = null, orders = null }) {
        if (attendees) {
            const to_rotate = attendees.filter(a => !a.removed);
            this.filtered_attendees = to_rotate;
            this.mode = RotateBarcode.TYPE;
            return Promise.resolve(true);
        }
        this.filtered_orders = orders || this.filtered_items;
        this.mode = this.constructor.TYPE;
        return Promise.resolve(true);
    }

    get post_action() {
        return true;
    }

    get withToastRun() {
        return false;
    }

    runPostAction({ items, mode, send_mail, to_reservation }) {
        if (mode === 'attendees') {
            return Attendee.perform_action(RotateBarcode.NAME, items, { organization: this.organization, event: this.event, send_mail, to_reservation });
        }

        return Order.perform_action(this.constructor.NAME, items, { organization: this.organization, event: this.event, send_mail, to_reservation });
    }
}
